import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { keyPoints } from '@/mocks/admissionData';

export default function KeyPoints() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('admission.points.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('admission.points.title')}
          </h2>
          {String(t('admission.points.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">{__s}</p>))}
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          {String(t('admission.points.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="border border-background-200/60 bg-background-50">
          {keyPoints.map((point, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-5 px-6 py-5 ${
                idx < keyPoints.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500/10 flex-shrink-0">
                <i className={`${point.icon} text-accent-600 text-sm`}></i>
              </div>
              <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                <span className="text-[13px] text-foreground-400 tracking-[0.08em] font-label whitespace-nowrap flex-shrink-0">
                  {lang === 'en' ? t(`admission.points.kp.${idx}.label`) : point.label}
                </span>
                <span className="text-[16px] text-foreground-800 tracking-[0.04em]">
                  {lang === 'en' ? t(`admission.points.kp.${idx}.value`) : point.value}
                </span>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-6">
          {t('admission.points.contactNote')}
          <Link to="/application" className="text-accent-600 hover:text-accent-500 underline underline-offset-2 transition-colors mx-1">
            {t('admission.points.contactLink')}
          </Link>
          {t('admission.points.contactSuffix')}
        </p>
      </div>
    </section>
  );
}
